export const PERSONAL_MODEL_SCOPE = "personal" as const;
export const ALL_PROJECTS_MODEL_SCOPE = "all" as const;

export type ModelQueryScope = {
  principalId: string;
  organizationId: string;
  projectId: string;
};

export type ModelRequestScope = {
  organizationId: string | null;
  projectId: string | null;
};

const scopeParts = (scope: ModelQueryScope) =>
  [
    scope.principalId,
    scope.organizationId || PERSONAL_MODEL_SCOPE,
    scope.projectId || ALL_PROJECTS_MODEL_SCOPE,
  ] as const;

export const modelScopeIdentity = (scope: ModelQueryScope) =>
  JSON.stringify(scopeParts(scope));

export const getModelRequestScope = (
  scope: ModelQueryScope,
): ModelRequestScope => ({
  organizationId:
    scope.organizationId === PERSONAL_MODEL_SCOPE
      ? null
      : scope.organizationId,
  projectId:
    scope.projectId === ALL_PROJECTS_MODEL_SCOPE ? null : scope.projectId,
});

export const modelQueryKeys = {
  lists: () => ["llm-configs", "list"] as const,
  list: (scope: ModelQueryScope) =>
    [...modelQueryKeys.lists(), ...scopeParts(scope)] as const,
  defaults: (scope: ModelQueryScope) =>
    ["default-models", ...scopeParts(scope)] as const,
};
